// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4110":"e6de8a829be95ddb","9991":"5a8b2ed2269c8a13"}[chunkId] + ".css";
};